import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId, useState } from "react";
import { cn } from "./cn.js";
const STATUS_LABELS = {
    pending: "Pending",
    running: "Running",
    success: "Succeeded",
    error: "Failed",
};
export function ToolCall({ name, status = "pending", meta, pane, paneRef, open, defaultOpen = false, onOpenChange, statusLabel, className, children, ...rest }) {
    const paneId = useId();
    const [selfOpen, setSelfOpen] = useState(defaultOpen);
    const isControlled = open !== undefined;
    const isOpen = pane !== undefined && (isControlled ? open : selfOpen);
    const toggle = () => {
        const next = !isOpen;
        if (!isControlled)
            setSelfOpen(next);
        onOpenChange?.(next);
    };
    const rowContent = (_jsxs(_Fragment, { children: [_jsxs("span", { className: "fwfa-tool-call-mark", children: [_jsx(StatusGlyph, { status: status }), _jsx("span", { className: "fwfa-sr-only", children: statusLabel ?? STATUS_LABELS[status] })] }), _jsx("span", { className: "fwfa-tool-call-label", children: name }), meta != null && _jsx("span", { className: "fwfa-tool-call-meta", children: meta }), pane !== undefined && (_jsx("span", { className: "fwfa-tool-call-chevron", "aria-hidden": "true", children: _jsx("svg", { width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "m6 9 6 6 6-6" }) }) }))] }));
    return (_jsxs("div", { className: cn("fwfa-tool-call", className), "data-status": status, "data-open": isOpen ? "true" : undefined, ...rest, children: [pane === undefined ? (_jsx("div", { className: "fwfa-tool-call-row", children: rowContent })) : (_jsx("button", { type: "button", className: "fwfa-tool-call-row", "aria-expanded": isOpen, "aria-controls": paneId, onClick: toggle, children: rowContent })), isOpen &&
                (pane === "terminal" ? (_jsx("div", { id: paneId, ref: paneRef, className: "fwfa-tool-call-pane fwfa-tool-call-pane--terminal", children: children })) : (_jsx("pre", { id: paneId, className: "fwfa-tool-call-pane", children: children })))] }));
}
// The four state glyphs. Each is a different shape, not just a different colour:
// a hollow ring waiting, a broken ring turning, a tick, a cross.
function StatusGlyph({ status }) {
    const common = {
        width: 13,
        height: 13,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
    };
    if (status === "running") {
        return (_jsxs("svg", { ...common, className: "fwfa-tool-call-spinner", children: [_jsx("circle", { cx: "12", cy: "12", r: "9", opacity: "0.25" }), _jsx("path", { d: "M21 12a9 9 0 0 0-9-9" })] }));
    }
    if (status === "success") {
        return (_jsx("svg", { ...common, children: _jsx("path", { d: "m4.5 12.75 6 6 9-13.5" }) }));
    }
    if (status === "error") {
        return (_jsxs("svg", { ...common, children: [_jsx("path", { d: "M18 6 6 18" }), _jsx("path", { d: "m6 6 12 12" })] }));
    }
    return (_jsx("svg", { ...common, children: _jsx("circle", { cx: "12", cy: "12", r: "9", opacity: "0.55" }) }));
}
//# sourceMappingURL=ToolCall.js.map